module.exports = __WEBPACK_EXTERNAL_MODULE_116__;


//////////////////
// WEBPACK FOOTER
// external "react-dropzone"
// module id = 116
// module chunks = 0